import { render, staticRenderFns } from "./ns-spinner-color-circle.vue?vue&type=template&id=3332abc3&scoped=true&"
var script = {}
import style0 from "./ns-spinner-color-circle.vue?vue&type=style&index=0&id=3332abc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332abc3",
  null
  
)

export default component.exports